import React, { Component } from 'react';
import { Navbar, Container, Nav } from 'react-bootstrap';

class Footer extends Component {
    render() {
        return (
            <Navbar 
                collapseOnSelect 
                expand="lg" 
                variant="dark"
                style={{
                    background: 'linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)',
                    boxShadow: '0 -2px 8px rgba(0, 0, 0, 0.1)',
                    padding: window.innerWidth < 600 ? '12px 0' : '16px 0',
                    marginTop: window.innerWidth < 600 ? '30px' : '50px'
                }}
            >
                <Container>
                    <Nav className="me-auto" style={{ 
                        display: "flex", 
                        flexDirection: "row", 
                        justifyContent: "space-around", 
                        width: "100%" 
                    }}>
                        <Nav.Link 
                            href="/impressum"
                            style={{
                                fontWeight: 500,
                                fontSize: window.innerWidth < 600 ? '0.85rem' : '1rem',
                                color: 'rgba(255, 255, 255, 0.9)',
                                fontFamily: 'Inter, sans-serif',
                                textAlign: 'center'
                            }}
                        >
                            Impressum und Datenschutz
                        </Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
        )
    }
}

export default Footer;